
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardSelect",
  props: {
    isSelect: {
      type: Boolean
    },
    isRemove: {
      type: Boolean
    },
    disable: {
      type: Boolean
    },
    label: {
      type: String,
      default: "Text",
      required: true
    }
  },
  setup() {}
});
